import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import { SticksProductUnavailable } from "../../containers/SticksProductDetailsContainer/components";
export const SticksDataContext = createContext(undefined);
export const SticksDataProvider = ({ children, sticksMap, fallbackProductsSkus, ...props }) => {
    const [contextData, setContextData] = useState(props);
    const setCurrentSKU = (sku) => {
        setContextData((prevValue) => ({ ...prevValue, sku }));
    };
    const currentProduct = sticksMap.get(contextData.sku);
    if (!currentProduct)
        return _jsx(SticksProductUnavailable, {});
    const contextValue = {
        data: contextData,
        setCurrentSKU,
        currentProduct,
        fallbackProductsSkus,
    };
    return _jsx(SticksDataContext.Provider, { value: contextValue, children: children });
};
//# sourceMappingURL=SticksDataProvider.js.map